import { initGraphQLTada } from "gql.tada";
export * from "../../types.js";
import { readFragment, maskFragments } from "gql.tada";
const graphql = initGraphQLTada();
export {
  graphql,
  maskFragments,
  readFragment
};
